'use client';

import type { ReactElement, ReactNode } from 'react';
import { Chackerheader } from '../Chackerheader';
import { Temper } from '@/types/frontend-types';
import { dataEl, type DataElScope } from '@/utils/dataEl';

interface MessageModalHeaderProps {
  dataElScope: DataElScope;
  title: string;
  titleNode?: ReactNode;
  hackerAllCaps: boolean;
  temper: Temper;
}

export function MessageModalHeader({
  dataElScope,
  title,
  titleNode,
  hackerAllCaps,
  temper,
}: MessageModalHeaderProps): ReactElement {
  if (titleNode != null) {
    return (
      <div
        data-el={dataEl(dataElScope, 'Header/Root')}
        aria-label={title}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 16,
          color: 'white',
          fontSize: 18,
          fontWeight: 600,
        }}
      >
        <span>[</span>
        <span>{titleNode}</span>
        <span>]</span>
      </div>
    );
  }
  return (
    <Chackerheader
      text={hackerAllCaps ? title.toUpperCase() : title}
      temper={temper}
      fontSize={18}
      gap={16}
    />
  );
}
